/** Material kinds passed to authentication providers. */
export enum AuthenticationMaterialType {
  Secret = 0,
  Key = 1,
  Identity = 2,
  Data = 3,
}
